import {JwtAxios} from "@/packaging";
import dayjs from "dayjs";

export const dbAPI = {
    async GetCollectDB(model){
        const responseModel = await JwtAxios.get(`/DB/GetCollectDB`, model);
        return responseModel
    },
    async GetCollect2DB(model){
        const responseModel = await JwtAxios.get(`/DB/GetCollect2DB`, model);
        return responseModel
    },

    async ExportExcel(model){
        const responseModel = await JwtAxios.download(`/DB/ExportExcel`,model);
        return responseModel
    },
    async ExportExcel2(model){
        const responseModel = await JwtAxios.download(`/DB/ExportExcel2`,model);
        return responseModel
    },
    async SetCollectDBStatus(model){
        const responseModel = await JwtAxios.get(`/DB/SetCollectDBStatus`, model);
        return responseModel
    },
    async SetCollect2DBStatus(model){
        const responseModel = await JwtAxios.get(`/DB/SetCollect2DBStatus`, model);
        return responseModel
    },
    async RemoveCollectDB(model){
        const responseModel = await JwtAxios.post(`/DB/DeleteCollectDB`, model);
        return responseModel
    },
    async RemoveCollect2DB(model){
        const responseModel = await JwtAxios.post(`/DB/DeleteCollect2DB`, model);
        return responseModel
    },
    async GetPlaceDB(model){
        const responseModel = await JwtAxios.get(`/DB/GetPlaceDB`, model);
        return responseModel
    },
    async GetRegisterDB(model){
        const responseModel = await JwtAxios.get(`/DB/GetRegisterDB`, model);
        return responseModel
    },
    async GetMyDB(model){
        const responseModel = await JwtAxios.get(`/DB/GetMyDB`, model);
        return responseModel
    },
    async GetRankHistory(model){
        const responseModel = await JwtAxios.get(`/DB/GetRankHistory`, model);
        return responseModel
    },
    async CheckNaverLank(model){
        const responseModel = await JwtAxios.get(`/Naver/CheckNaverLank`, model);
        return responseModel
    },
    async SetPlaceDB(model){
        const responseModel = await JwtAxios.post(`/DB/SetPlaceDB`, model);
        return responseModel
    },
    async SetRegisterDB(model){
        const responseModel = await JwtAxios.post(`/DB/SetRegisterDB`, model);
        return responseModel
    },
    async SetMyDB(model){
        const responseModel = await JwtAxios.post(`/DB/SetMyDB`, model);
        return responseModel
    },
    async UpdatePlaceDB(model){
        const responseModel = await JwtAxios.post(`/DB/UpdatePlaceDB`, model);
        return responseModel
    },
    async UpdateRegisterDB(model){
        const responseModel = await JwtAxios.post(`/DB/UpdateRegisterDB`, model);
        return responseModel
    },
    async UpdateMyDB(model){
        const responseModel = await JwtAxios.post(`/DB/UpdateMyDB`, model);
        return responseModel
    },
    async RemovePlaceDB(model){
        const responseModel = await JwtAxios.post(`/DB/RemovePlaceDB`, model);
        return responseModel
    },
    async RemoveRegisterDB(model){
        const responseModel = await JwtAxios.post(`/DB/RemoveRegisterDB`, model);
        return responseModel
    },
    async RemoveMyDB(model){
        const responseModel = await JwtAxios.post(`/DB/RemoveMyDB`, model);
        return responseModel
    },
}